import { Fragment, ReactElement } from 'react';
import RegisterCohabitationNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-cohabitation/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const RegisterCohabitationNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <RegisterCohabitationNotificationCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

RegisterCohabitationNotificationCivilStatusPage.displayName =
  'Research Cohabitation Notifications Detail Page component';

export default RegisterCohabitationNotificationCivilStatusPage;
